import Layout from "components/Layout";
import React from "react";
import UserEditForm from "./components/UserEditForm";

function AdminUserEditPage() {
  return (
    <Layout title="사용자 수정/삭제">
      <UserEditForm />
    </Layout>
  );
}

export default AdminUserEditPage;
